export default () => {
	$( '.js-news-load' ).click( function ( e ) {
		e.preventDefault();
		$( '.news__list-item' ).show();
		$( this ).parent().remove();
	} );
};
